import React, { useEffect, useRef } from 'react';
import { expectations } from '../mock';
import { Heart } from 'lucide-react';

const LeafBullet = () => (
  <svg viewBox="0 0 24 24" className="w-5 h-5 shrink-0 mt-0.5" aria-hidden="true">
    <path d="M3 14c4-9 11-11 18-11 0 7-2 14-11 18-4 2-7-3-7-7z" fill="#a8b870" />
    <path d="M3 21c5-7 11-12 18-18" stroke="#3a5232" strokeWidth="0.8" fill="none" />
  </svg>
);

const Expect = () => {
  const ref = useRef(null);
  useEffect(() => {
    const els = ref.current?.querySelectorAll('.reveal');
    if (!els) return;
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add('is-visible')),
      { threshold: 0.15 }
    );
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <section id="expect" ref={ref} className="py-20 md:py-28 relative bg-[#f8f3e6]">
      <div className="max-w-7xl mx-auto px-5 md:px-10 grid lg:grid-cols-2 gap-8 lg:gap-12 items-stretch">
        {/* Left dark card */}
        <div className="reveal relative bg-[#3a5232] rounded-[28px] p-8 md:p-12 text-[#f0e9d2] overflow-hidden">
          <div className="absolute -top-10 -right-10 w-48 h-48 rounded-full bg-[#4a6240] opacity-40 blur-2xl" />
          <div className="absolute -bottom-12 -left-8 w-56 h-56 rounded-full bg-[#2c3f25] opacity-50 blur-3xl" />
          <div className="relative">
            <p className="font-script text-3xl md:text-4xl text-[#d8e0b0] mb-8">What you can expect:</p>
            <ul className="space-y-4 md:space-y-5">
              {expectations.map((item, i) => (
                <li key={i} className="flex items-start gap-3 text-[15px] md:text-[17px]">
                  <LeafBullet />
                  <span className="text-[#f0e9d2]">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Right cream card */}
        <div className="reveal cream-card rounded-[28px] p-8 md:p-12 relative overflow-hidden flex flex-col md:flex-row items-center gap-6">
          <div className="shrink-0">
            <img
              src="https://images.pexels.com/photos/3561063/pexels-photo-3561063.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt="Stacked zen stones with sprout"
              className="w-36 h-44 md:w-44 md:h-56 object-cover rounded-xl shadow-md"
            />
          </div>
          <div className="text-center md:text-left">
            <p className="text-[#3d4a36] text-base md:text-lg">It’s okay to not be okay.</p>
            <p className="font-script text-3xl md:text-4xl text-[#3a5232] mt-1">It’s okay to seek help.</p>
            <div className="flex items-center justify-center md:justify-start gap-2 mt-4">
              <span className="h-px w-8 bg-[#8fa05a]" />
              <Heart size={14} className="text-[#8fa05a] fill-[#cfe0a8]" />
              <span className="h-px w-8 bg-[#8fa05a]" />
            </div>
            <p className="text-[#3d4a36] text-base md:text-lg mt-4 leading-relaxed">
              Let’s take the first step <br /> towards healing — together.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Expect;
